import {
  entityTypes,
  externalIdEntityTypes,
  languages,
  mandants,
  pubtypeGroups,
  pubtypes,
  userRoles,
  workFields,
  workFormPages,
} from '../Settings/data';
import {
  SearchOrganisationRequest,
  SearchPersonRequest,
  SearchProjectRequest,
  SearchRequestSort,
  SearchWorkRequest,
  SolrOrganisationReduced,
  SolrPersonReduced,
  SolrProjectReduced,
  SolrResultSolrOrganisationReduced,
  SolrResultSolrPersonReduced,
  SolrResultSolrProjectReduced,
  SolrResultSolrWorkReduced,
  SolrWorkReduced,
} from '../api/core';
import { getDefaultWork } from '../Settings/emptyModels';
import { QueryFacet } from '../pages/dashboard/SearchResults';

import {
  AdminDataOrganisationDTO,
  AdminDataPersonDTO,
  AdminDataProjectDTO,
  AdminDataWorkDTO,
  OrganisationDTO,
  PersonDTO,
  ProjectDTO,
  WorkDTO,
} from '../api/core/models';
import React from 'react';
import { ParsedFacet } from '../pages/dashboard/components/SearchFacets';

const availableUserRoles = [...userRoles] as const;
export type UserRole = typeof availableUserRoles[number];

const mandant = [...mandants] as const;
export type Mandant = typeof mandant[number];

export const themeNames = [...mandant] as const;
export type ThemeName = typeof themeNames[number];

const language = [...languages] as const;
export type Language = typeof language[number];

const workFormPage = [...workFormPages] as const;
export type WorkFormPage = typeof workFormPage[number];

const workProperties = [...Object.keys(getDefaultWork())] as const;
export type WorkProperty = typeof workProperties[number];

const workField = [...workFields] as const;
export type WorkField = typeof workField[number];

const pubtype = [...pubtypes] as const;
export type Pubtype = typeof pubtype[number];

const pubtypeGroup = [...pubtypeGroups] as const;
export type PubtypeGroup = typeof pubtypeGroup[number];

export type PubtypeGroupData = {
  [key in PubtypeGroup[number]]?: {
    pubtypes: Pubtype[];
    fields: WorkField[];
  }
};

export type PartRelationData = {
  [key in PubtypeGroup[number]]?: {
    [key2 in PubtypeGroup[number]]?: FieldSettings;
  };
};

export interface FieldSettings {
  volume: boolean;
  issue: boolean;
  pageFirst: boolean;
  pageLast: boolean;
  articleId: boolean;
}

export interface MandantSettings {
  mandant: Mandant;
  institution: string;
  usesOrcid: boolean;
  loginEnabled: boolean;
  domains: string[];
  topOrga: string;
  icon: string;
  jsScripts: string[];
  favicon?: string;
}

export interface LabelledSearchRequestSort {
  label: string;
  value: SearchRequestSort;
}

export interface FacetSetting {
  name: string;
  label: string;
  missingLabel?: string;
  postSort?: (a: ParsedFacet, b: ParsedFacet) => number;
  tristate?: boolean;
  parse: (facet: QueryFacet) => string;
  itemLabel: (label: string | boolean) => FacetLabel;
}

export type SolrEntity = SolrWorkReduced | SolrOrganisationReduced | SolrProjectReduced | SolrPersonReduced;
export type SolrResultSolrEntity =
  SolrResultSolrWorkReduced
  | SolrResultSolrPersonReduced
  | SolrResultSolrProjectReduced
  | SolrResultSolrOrganisationReduced;
export type SearchEntityRequest =
  SearchOrganisationRequest
  | SearchPersonRequest
  | SearchProjectRequest
  | SearchWorkRequest;



const entityType = [...entityTypes] as const;
export type EntityType = typeof entityType[number];

const externalIdEntityType = [...externalIdEntityTypes] as const;
export type ExternalIdEntityType = typeof externalIdEntityType[number];

export type EntityDTO = WorkDTO | PersonDTO | OrganisationDTO | ProjectDTO;
export type EntityAdminDTO = AdminDataWorkDTO | AdminDataPersonDTO | AdminDataOrganisationDTO | AdminDataProjectDTO;

export type FacetValue = string | number;
export type FacetEntry = SelectFacetEntry | DateFacetEntry;
export type FacetLabel = string | React.ReactNode;

type FacetLabelFactory = (child: (name: React.ReactNode) => React.ReactNode) => React.ReactNode;

export interface SelectFacetEntry {
  label: React.ReactNode | FacetLabelFactory;
  value: FacetValue;
  count: number | null;
  negate: boolean;
}

export interface DateFacetEntry {
  start?: Date;
  end?: Date;
}

export enum Direction {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type EnrichedValues = Partial<Record<keyof WorkDTO, unknown[]>>;
